export const DEV_MODE = process.env.REACT_APP_DEV_MODE === 'true';
export const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';
export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || '';
// Analytics / error monitoring — all optional; the SDKs hard no-op when these are absent.
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
export const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || '';
export const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
export const DEMO_VIDEO_URL = 'https://www.youtube.com/embed/GEgBVvobelo?rel=0&modestbranding=1&vq=hd1080';
